import routes from './routes';

export default {
  id: 'conversationRedistribution',
  routes,
};
